import React, { useEffect, useRef, useState } from 'react';
import { Button } from "react-bootstrap";
import {connect,  useDispatch, useSelector } from 'react-redux';
import { validation } from '../../../shared/form-validations';
import { content_groupActions } from '../../../actions';
import { textInput, hiddenField } from '../../../shared/form-elements'
import { reduxForm, Field, reset, change, formValueSelector } from "redux-form";
import CheckIcon from "../../../images/icons/white/check.svg";

function NewContentGroupSingleFieldForm(props) {
  const dispatch = useDispatch();
  const {
    stageId,
    workspace_id,
    handleSubmit,
    handleOpenContentGroupPopUp,
    handleClose,
    addContentGroupRowRef,
    loading,
    buttonAbsolutePositioning = false,
  } = props
  const [showForm, setShowForm] = useState(true)
  const intialLoaded = useRef(false)
  const formState = useSelector((state) => state.form?.content_groupform);
  const formIsReady = !!formState && !!formState.values;
  const selector = formValueSelector("content_groupform");
  const name = useSelector(state => selector(state, "name"));

  useEffect(() => {
    dispatch(change("content_groupform", "name", ''))
    dispatch(change("content_groupform", "stage_id", stageId));
    dispatch(change("content_groupform", "workspace_id", workspace_id));

    const handleKeyDown = (event) => {
      if (event.key == "Escape") {
        handleClose()
      }
    }

    document.addEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    if(stageId === undefined || workspace_id === undefined || !formIsReady) {
      return;
    }
    dispatch(change("content_groupform", "stage_id", stageId));
    dispatch(change("content_groupform", "workspace_id", workspace_id));
  }, [stageId, workspace_id, formIsReady, name]);

  useEffect(() => {
    const onClick = e => {
      if(intialLoaded.current) {
        if (addContentGroupRowRef.current !== null && !addContentGroupRowRef.current.contains(e.target)) {
          setShowForm(false);
        } else {
          setShowForm(true);
        }
      } else {
        intialLoaded.current = true
      }
    };

    window.addEventListener("click", onClick);

    return () => {
      window.removeEventListener("click", onClick);
    };
  }, []);

  useEffect(() => {
    if (!showForm) {
      handleClose();
    }
  }, [showForm]);

  return (
    <div className="content-group-form">
      <form 
        onSubmit={(e) => (loading || props.invalid) ? null : handleSubmit(e)}
        className=''
      >
        <Field 
          component={textInput} 
          name="name" type="text" 
          placeholder="Add title" 
          className='flex-grow-1' 
          autoFocus 
          noErrorDisplay
        />
        <Field component={ hiddenField } name="stage_id" type="hidden" value={props.stageId}/>
        <Field component={ hiddenField } name="workspace_id" type="hidden"  value={props.workspace_id}/>

        <div 
          className={`justify-content-end d-flex ${buttonAbsolutePositioning ? 'position-absolute end-0' : ''}`}
          style={ buttonAbsolutePositioning ? { bottom: '-36px' } : {marginTop: '6px'}}
        >
          <Button 
            variant="white" 
            className='px-3 rounded-corners mx-1 h-30px' 
            onClick={handleClose} 
            size={'sm'}
          >
            Cancel
          </Button>
          <Button 
            variant="success" 
            type="submit" 
            disabled={loading || props.invalid || intialLoaded.current === false} 
            className='px-3 rounded-corners mx-1 h-30px'
            size={'sm'}
          >
            Add
          </Button>
        </div>
      </form>
    </div>
  );
}

NewContentGroupSingleFieldForm = reduxForm({
  form: 'content_groupform',
  validate: validation,
  enableReinitialize: true
})(NewContentGroupSingleFieldForm);

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.content_group.content_group_loading
  };
};

export default connect(mapStateToProps, { content_groupActions })(NewContentGroupSingleFieldForm);
